module.exports = __webpack_public_path__ + "img/ListCard.fa44980d.png";